import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { userService } from "../services/userService";
import { useNavigate } from "react-router-dom";
import Toast from "./Toast"; 

const AccountDeactivated: React.FC = () => {
  const { currentUser, userData } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [toast, setToast] = useState({
    open: false,
    type: "success" as "success" | "error" | "warning" | "info",
    message: "",
  });

  const showToast = (type: "success" | "error" | "warning" | "info", message: string) => {
    setToast({ open: true, type, message });
    setTimeout(() => setToast((prev) => ({ ...prev, open: false })), 3000);
  };

  const handleReactivate = async () => {
    if (!currentUser?.uid) return;
    setLoading(true);

    try {
      await userService.activateUser(currentUser.uid);
      showToast("success", "✅ Your account has been reactivated successfully!");
      setTimeout(() => {
        window.location.href = "/dashboard"; // full reload redirect
      }, 1000);
    } catch (error) {
      console.error("Error reactivating account:", error);
      showToast("error", "❌ Failed to reactivate account. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-base-100 px-6">
      <div className="max-w-md w-full bg-base-100 rounded-2xl shadow-md p-8 text-center">
        <h1 className="text-2xl font-semibold text-base-content mb-4">
          Account Deactivated
        </h1>
        <p className="text-base-content/80 mb-6">
          Your account is currently <strong>deactivated</strong>. You cannot
          access features until it’s reactivated.
        </p>
        <button
          onClick={handleReactivate}
          disabled={loading}
          className="bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-2 rounded-md font-medium disabled:opacity-50 transition-all"
        >
          {loading ? "Reactivating..." : "Reactivate Account"}
        </button>
      </div>

      {/* ✅ Toast Notification */}
      <Toast
        open={toast.open}
        type={toast.type}
        message={toast.message}
        onClose={() => setToast((prev) => ({ ...prev, open: false }))}
      />
    </div>
  );
};

export default AccountDeactivated;
